import axios from 'axios';
import { put, call } from 'redux-saga/effects';

// CONSTANTS
import { PROFILES_GET_LIST, PROFILES_LOGIN_AS_USER } from '@/constants/api';

// UTILITY
import { showErrorNotification } from '@/utility/saga';

// STORE
import { ProfilesActions } from '@/store/actions';
import { getLink } from '@/utility/routes';

const { getProfiles, loginAsProfileUser } = ProfilesActions;

export function* getProfilesSaga(action) {
  yield put({ type: getProfiles.types.START });

  const { params } = action.payload;

  try {
    const { data: respData } = yield axios.get(PROFILES_GET_LIST, { params });

    yield put({
      type: getProfiles.types.SUCCESS,
      payload: {
        data: respData.data,
        meta: respData.meta,
      },
    });
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put({
      type: getProfiles.types.FAIL,
    });
  }
}

export function* loginAsProfileUserSaga(action) {
  yield put({ type: loginAsProfileUser.types.START });

  const { user_id, params = {} } = action.payload;
  const url = getLink(PROFILES_LOGIN_AS_USER, { user_id });

  try {
    const { data: respData } = yield axios.get(url, { params });

    if (respData.url) {
      window.open(respData.url, '_blank');
    }

    yield put({
      type: loginAsProfileUser.types.SUCCESS,
    });
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put({
      type: loginAsProfileUser.types.FAIL,
    });
  }
}

export default getProfilesSaga;
